module.exports = __webpack_public_path__ + "static/media/get.3604ce87.svg";